import { render, staticRenderFns } from "./ad-detail.vue?vue&type=template&id=12c92be4&scoped=true&"
import script from "./ad-detail.vue?vue&type=script&lang=js&"
export * from "./ad-detail.vue?vue&type=script&lang=js&"
import style0 from "./ad-detail.vue?vue&type=style&index=0&id=12c92be4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c92be4",
  null
  
)

component.options.__file = "ad-detail.vue"
export default component.exports